import Vue, { PluginObject } from "vue";
import axios from "axios";

const config = {

};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    (cfg) => {
        // HODU_WEB_MAIN은 device-uid, session_token 상관없는 API만 호출
        return cfg;
    },
    (err) => {
        // Do something with request error
        return Promise.reject(err);
    },
);

// Add a response interceptor
_axios.interceptors.response.use(
    (res) => {
        // Do something with response data
        return res;
    },
    (err) => {
        // Do something with response error
        return Promise.reject(err);
    },
);

const Plugin: PluginObject<any> = {
    install: (Vue) => {
        Vue.$http = _axios;
    },
};

Plugin.install = (Vue) => {
    Vue.$http = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        $http: {
            get() {
            return _axios;
            },
        },
    });
};

Vue.use(Plugin);

export default Plugin;
